export default __webpack_public_path__ + "static/media/img13.aec8d82c.webp";